import { createFileRoute } from '@tanstack/react-router';
import { SheetReviewPage } from '@/features/sync/SheetReviewPage';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { readSyncSearch, syncSearchSchema, syncViewProps } from '@/features/sync/syncSearch';

export const Route = createFileRoute('/_authenticated/people/review')({
  validateSearch: syncSearchSchema,
  component: function PeopleReview() {
    const cur = readSyncSearch(Route.useSearch());
    const navigate = Route.useNavigate();
    return (
      <SheetReviewPage
        config={SHEET_TABS.hr}
        {...syncViewProps(cur, (search) => void navigate({ search, replace: true }))}
      />
    );
  },
});
